import { IconAlertTriangle, IconDeviceFloppy } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { Button, Grid, Group, Modal, NumberInput, Text, TextInput } from '@mantine/core';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';

const PageSettingsModal = ({ isOpen, close, updated, pageId }) => {
  const { accountId, domainId } = useParams();
  const fetch = useFetch();
  const [page, setPage] = useState();
  const [error, setError] = useState();

  useEffect(() => {
    const getPage = () => {
      fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pages/${pageId}`)
        .then(({ page }) => {
          setPage(page);
        })
        .catch(setError);
    };
    if (pageId) {
      getPage();
    }
  }, [fetch, accountId, domainId, pageId]);

  const saveUrl = () => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pages/${page.id}`, {
      method: 'PUT',
      body: JSON.stringify(page),
    })
      .then(({ page }) => {
        updated();
        setPage(page);
        setError(undefined);
      })
      .catch((error) => {
        setError(error);
      });
  };

  return (
    <Modal size="lg" opened={isOpen} onClose={() => close()} title="Page Settings">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          saveUrl();
        }}
      >
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Page Name</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <TextInput
              name="name"
              value={page?.name || ''}
              placeholder="Enter page name"
              onChange={(e) => setPage((prev) => ({ ...prev, [e.target.name]: e.target.value }))}
            />
          </Grid.Col>
        </Grid>
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>URL Path</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <TextInput
              name="pathname"
              value={page?.pathname || ''}
              placeholder="/black-friday-2023"
              error={page?.pathname && page.pathname.endsWith('/') ? 'The Path must NOT end with a slash (/).' : null}
              onChange={(e) => setPage((prev) => ({ ...prev, [e.target.name]: e.target.value }))}
            />
            <Text size="xs" c="dimmed" mt="xs">
              Add the pathname (NOT the full URL) of the page where you intend to showcase the recommenders/banners.
            </Text>
            {error && (
              <Text c="red" size="sm" mt="xs">
                <IconAlertTriangle size={14} style={{ display: 'inline', marginRight: 4 }} />
                {error.message}
              </Text>
            )}
          </Grid.Col>
        </Grid>
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Max Banners Displayed</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <NumberInput
              value={page?.bannerMaxDisplay ?? ''}
              placeholder="No limit"
              min={1}
              allowDecimal={false}
              allowNegative={false}
              onChange={(value) => setPage((prev) => ({ ...prev, bannerMaxDisplay: value === '' ? null : value }))}
            />
            <Text size="xs" c="dimmed" mt="xs">
              Max banners shown per push. Priority is determined by drag order.
            </Text>
          </Grid.Col>
        </Grid>
        <Group justify="flex-end" mt="md">
          <Button variant="default" onClick={() => close()}>
            Close
          </Button>
          <Button type="submit" disabled={page?.pathname && page.pathname.endsWith('/')} leftSection={<IconDeviceFloppy size={16} />}>
            Save
          </Button>
        </Group>
      </form>
    </Modal>
  );
};

export default PageSettingsModal;
